'use client';

import { useEffect } from 'react';

interface UseModalOptions {
  isOpen: boolean;
  onClose: () => void;
  closeOnEscape?: boolean;
  lockScroll?: boolean;
}

export const useModal = ({
  isOpen,
  onClose,
  closeOnEscape = true,
  lockScroll = true,
}: UseModalOptions) => {
  const unLockScroll = () => {
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (closeOnEscape && e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      if (closeOnEscape) {
        document.addEventListener('keydown', handleKeyDown);
      }

      if (lockScroll) {
        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      }
    } else {
      if (lockScroll) {
        unLockScroll();
      }
    }

    return () => {
      if (closeOnEscape) {
        document.removeEventListener('keydown', handleKeyDown);
      }

      if (lockScroll) {
        unLockScroll();
      }
    };
  }, [isOpen, onClose, closeOnEscape, lockScroll]);
};
